import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface SmsGatewayNumber {
    id: number;
    name: string;
    sms_gateways_numbers: {
        gateway_number: string,
        id: number,
    }[]
}

interface SmsGatewaynumber {
    smsgatewaynumber: SmsGatewayNumber[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}


// ====================-SmsCampgain-listing-action-start==============
export const GetallsmsGatewayNumber = createAsyncThunk<
    { data: SmsGatewayNumber[], info: { count: number; current_page: number; limit: number; total_page: number } },
    { search: string; page: number; limit: number },
    { rejectValue: string }
>(
    'GetallsmsGatewayNumber',
    async ({ search, page, limit }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`api/admin/sms-gateways-numbers/list`, {
                params: { search, page, limit },
            });
            return { data: response.data.data, info: response.data.info };
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
// ====================SmsCampgain-listing-action-start==============

const initialState: SmsGatewaynumber = {
    smsgatewaynumber: [],
    info: null,
    error: null,
    loading: false,
};

const smsgatewaynumberSlice = createSlice({
    name: "Smsgatewaynumber",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-smsgateway-number-slice-start============
            .addCase(GetallsmsGatewayNumber.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallsmsGatewayNumber.fulfilled, (state, action: PayloadAction<{ data: SmsGatewayNumber[], info: { count: number; current_page: number; limit: number; total_page: number } }>) => {
                state.loading = false;
                state.smsgatewaynumber = action.payload.data;
                state.info = action.payload.info;
            })
            .addCase(GetallsmsGatewayNumber.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-smsgateway-number-slice-start============
    },
});

export default smsgatewaynumberSlice.reducer;